// 全局设置使用,
import { getLanguage } from '@/lang/index'
import Cookies from 'js-cookie'

// 定义字段
const state = {
    token: sessionStorage.getItem('admin-token'),
    commonConfig: sessionStorage.getItem('common-config'),  // 配置1
    commonLanguage: sessionStorage.getItem('common-language'),  // 配置1
    userInfo: sessionStorage.getItem('admin-info'),  // 用户
    language: getLanguage(),
}


// 存储方式
const mutations = {
    setToken: (state, token) => {
      sessionStorage.setItem('admin-token', token)
      state.token = token
    },
    setUser: (state, info) => {
      sessionStorage.setItem('admin-info', JSON.stringify(info))
      state.userInfo = JSON.stringify(info)
    },
    setLanguage: (state, language) => {
      state.language = language
      Cookies.set('language', language)
    },
    //配置
    setCommonConfig: (state, item) => {
      sessionStorage.setItem('common-config', JSON.stringify(item))
      state.commonConfig = JSON.stringify(item)
    },
    //配置-lang
    setCommonLanguage: (state, item) => {
      sessionStorage.setItem('common-language', JSON.stringify(item))
      state.commonLanguage = JSON.stringify(item)
    },
}

// 输出数据
export default {
    // namespaced: true,//namespaced: true 的方式使其成为带命名空间的模块。保证在变量名一样的时候，添加一个父级名拼接。
    // 格式：模块名/模块中的mutations
    // xxx/setUserInfo
    // this.$store.commit(“userInfo/setUserInfo”,userInfo)
    state,
    mutations,
}